import { BiCheck, BiSkipNext } from 'react-icons/bi';
import { Z_TUTORIAL } from './TutorialContext';

/**
 * O fim do tutorial: diz como terminou e oferece o próximo da trilha.
 *
 * `discreto` quando o último passo abriu alguma coisa: no rodapé e sem
 * escurecido, para não cobrir o que a pessoa acabou de abrir.
 */
const CartaoFinal = ({ tutorial, proximo, pulado = false, discreto = false, aoComecarProximo, aoFechar }) => (
  <div
    role="dialog"
    aria-modal={discreto ? undefined : true}
    aria-labelledby="tutorial-final-titulo"
    className={`tutorial-final-chega fixed left-1/2 w-[min(360px,calc(100vw-24px))] -translate-x-1/2 rounded-xl border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 p-5 shadow-vox-2xl ${
      discreto ? 'bottom-6' : 'top-1/2 -translate-y-1/2'
    }`}
    style={{ zIndex: Z_TUTORIAL }}
  >
    <div className="mb-3 flex items-center gap-2.5">
      {pulado ? (
        <span className="flex h-7 w-7 items-center justify-center rounded-full bg-gray-100 text-gray-500 dark:bg-gray-700 dark:text-gray-300">
          <BiSkipNext className="h-5 w-5" />
        </span>
      ) : (
        <span className="flex h-7 w-7 items-center justify-center rounded-full bg-vox-green-600 text-white">
          <BiCheck className="h-5 w-5" />
        </span>
      )}
      <h2 id="tutorial-final-titulo" className="text-sm font-semibold text-gray-900 dark:text-white">
        {tutorial.titulo}: {pulado ? 'pulado' : 'feito'}.
      </h2>
    </div>

    {proximo ? (
      <p className="text-sm leading-relaxed text-gray-600 dark:text-gray-300">
        O próximo da trilha é <span className="font-medium text-gray-900 dark:text-white">{proximo.titulo}</span>.{' '}
        {proximo.descricao}
      </p>
    ) : (
      <p className="text-sm leading-relaxed text-gray-600 dark:text-gray-300">
        Você já passou por todos os tutoriais. Para rever qualquer um, é só voltar em Tutoriais.
      </p>
    )}

    <div className="mt-4 flex items-center justify-end gap-2">
      <button
        type="button"
        onClick={aoFechar}
        className="whitespace-nowrap rounded-lg border border-gray-300 px-3 py-1.5 text-sm font-semibold text-gray-700 transition-colors hover:bg-gray-100 dark:border-gray-600 dark:text-gray-200 dark:hover:bg-gray-700"
      >
        {proximo ? 'Agora não' : 'Fechar'}
      </button>
      {proximo && (
        <button
          type="button"
          onClick={aoComecarProximo}
          className="whitespace-nowrap rounded-lg bg-vox-green-600 px-3 py-1.5 text-sm font-semibold text-white transition-colors hover:bg-vox-green-700"
        >
          Começar o próximo
        </button>
      )}
    </div>
  </div>
);

export default CartaoFinal;
